import { mockAiQuota } from '../mock/ai';
import type { AiQuotaView } from './ai.types';

/**
 * Chưa có module AI ở apps/api — getQuota trả dữ liệu giả nhưng ĐÚNG hình dạng
 * một lệnh gọi API thật (Promise<AiQuotaView>). Khi backend có endpoint,
 * chỉ đổi thân hàm thành `apiGet<AiQuotaView>('/me/ai/quota')`, UI không phải sửa.
 */
export const aiApi = {
  getQuota: async (): Promise<AiQuotaView> => mockAiQuota,
};
